<template>
  <div class="ui-null-center-img">
    <div class="inner">
      <img :src="toSrc" />
      <div style="color:#999999">暂无记录</div>
    </div>
  </div>
</template>
<script>
import null_data from '@/assets/images/common/nulldata.png'
export default {
  name: 'ui-null-data',
  props: {

    type: {
      type: String,
      default: ""
    }
  },
  computed: {
    toSrc () {
      return null_data
    }
  }
}
</script>

<style lang="less" scoped>
.ui-null-center-img {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 100%;
  margin-top: 50px;

  .inner {
    text-align: center;

    img {
      width: 60%;
      // margin-left: 20%;
    }
    div {
      text-align: center;
      font-size: 14px;
      margin-top: 15px;
    }
  }
}
</style>
